import { updateLinksAttributes } from '../../utils/handleAttributes';

export default function premiumSponsors() {
  const widgetName = 'premiumSponsors';
  const widgetOpts = premiumSponsorsOpts;
  const $widget = $(`#${widgetName}`);

  const wrapContainerClass = 'premiumSponsors-wrap-container';

  $widget.wrap(`<div class="${wrapContainerClass}"></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 10,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createPremiumSponsors(data.items, $widget);
      } else {
        $widget.remove();
      }
    },
  });

  function createPremiumSponsors(widgetData, $widget) {
    $widget.find('.card-content').remove();
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $sponsor = $(this);
      updateLinksAttributes(URL, Title, $sponsor);
    });
  }
}
